import {
  combineReducers
} from "redux";


import auth from './auth'
import userManagement from './userManagement';

import global from './global';
import dashboard from './dashboard';
import settings from './settings';
import alerts from "./alerts";
import account from "./account";
import loan from "./loan";
import investorTracker from "./investorTracker";
import businessTracker from "./businessTracker";
import api from "./api";

const rootReducer = combineReducers({
  auth,
  userManagement,
  global,
  dashboard,
  settings,
  alerts,
  account,
  loan,
  investorTracker,
  businessTracker,
  api,

});

export default rootReducer;